"use client";
import { useState } from "react";

const services = [
  "Carbon & Climate Advisory",
  "GHG Accounting & Reporting",
  "Policy Advisory",
  "Quality Assurance Advisory",
  "Think-Tank & Innovation",
  "Legally-Backed Advisory",
  "Multiple / Not Sure",
];

export default function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    organisation: "",
    service: "",
    message: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="border border-[#dde7cd] p-12 lg:p-16 bg-white text-center">
        <div className="w-10 h-10 rounded-full border border-[#4a7c35] flex items-center justify-center mx-auto mb-6">
          <svg viewBox="0 0 16 16" fill="none" className="w-4 h-4 text-[#4a7c35]" strokeWidth={2}>
            <path d="M3 8l3.5 3.5L13 5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h3 className="font-bold tracking-tight text-3xl text-[#1e3a14] mb-4">Message received.</h3>
        <p className="text-[#5b6b51] text-base leading-relaxed max-w-sm mx-auto">
          Thank you for reaching out. An expert from our team will be in touch
          within 1–2 business days.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="border border-[#dde7cd] p-8 lg:p-12 bg-white">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-[10px] font-mono tracking-[0.2em] uppercase text-[#5b6b51] mb-2">
            Full Name <span className="text-[#4a7c35]">*</span>
          </label>
          <input
            type="text" name="name" value={form.name} onChange={handleChange} required
            placeholder="Your full name"
            className="w-full border border-[#dde7cd] bg-[#eef5e4] px-4 py-3 text-sm text-[#1e3a14] placeholder:text-[#9db98c] focus:outline-none focus:border-[#4a7c35] transition-colors duration-200 rounded-[1px]"
          />
        </div>
        <div>
          <label className="block text-[10px] font-mono tracking-[0.2em] uppercase text-[#5b6b51] mb-2">
            Email Address <span className="text-[#4a7c35]">*</span>
          </label>
          <input
            type="email" name="email" value={form.email} onChange={handleChange} required
            placeholder="you@organisation.com"
            className="w-full border border-[#dde7cd] bg-[#eef5e4] px-4 py-3 text-sm text-[#1e3a14] placeholder:text-[#9db98c] focus:outline-none focus:border-[#4a7c35] transition-colors duration-200 rounded-[1px]"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-[10px] font-mono tracking-[0.2em] uppercase text-[#5b6b51] mb-2">
            Organisation
          </label>
          <input
            type="text" name="organisation" value={form.organisation} onChange={handleChange}
            placeholder="Company / Institution"
            className="w-full border border-[#dde7cd] bg-[#eef5e4] px-4 py-3 text-sm text-[#1e3a14] placeholder:text-[#9db98c] focus:outline-none focus:border-[#4a7c35] transition-colors duration-200 rounded-[1px]"
          />
        </div>
        <div>
          <label className="block text-[10px] font-mono tracking-[0.2em] uppercase text-[#5b6b51] mb-2">
            Area of Expertise
          </label>
          <select
            name="service" value={form.service} onChange={handleChange}
            className="w-full border border-[#dde7cd] bg-[#eef5e4] px-4 py-3 text-sm text-[#1e3a14] focus:outline-none focus:border-[#4a7c35] transition-colors duration-200 rounded-[1px] appearance-none"
          >
            <option value="">Select an area…</option>
            {services.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>

      <div className="mb-8">
        <label className="block text-[10px] font-mono tracking-[0.2em] uppercase text-[#5b6b51] mb-2">
          Your Message <span className="text-[#4a7c35]">*</span>
        </label>
        <textarea
          name="message" value={form.message} onChange={handleChange} required rows={5}
          placeholder="Briefly describe your challenge, project, or what you'd like to explore…"
          className="w-full border border-[#dde7cd] bg-[#eef5e4] px-4 py-3 text-sm text-[#1e3a14] placeholder:text-[#9db98c] focus:outline-none focus:border-[#4a7c35] transition-colors duration-200 rounded-[1px] resize-none"
        />
      </div>

      <div className="flex items-center justify-between gap-4">
        <p className="text-[#9db98c] text-xs font-mono">* Required fields</p>
        <button
          type="submit"
          className="group inline-flex items-center gap-3 rounded-full bg-[#B3D670] px-8 py-3.5 text-sm font-bold text-[#1e3a14] transition-all duration-200 hover:bg-[#c8e98a] hover:scale-[1.02]"
        >
          Send Message
          <svg viewBox="0 0 14 14" fill="none" className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5" strokeWidth={2}>
            <path d="M2 7h10M7 3l4 4-4 4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </form>
  );
}
